import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { RequireAuth, RequireAdmin } from "./components/RouteGuards";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import PanelPage from "./pages/PanelPage";
import RegistrarPage from "./pages/RegistrarPage";
import DirectorioPage from "./pages/DirectorioPage";
import HistorialPage from "./pages/HistorialPage";
import UsuariosPage from "./pages/UsuariosPage";
import AccesosPage from "./pages/AccesosPage";
import AreasComunesPage from "./pages/AreasComunesPage";
import VisitantesPage from "./pages/VisitantesPage";
import AjustesPage from "./pages/AjustesPage";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route
          element={
            <SettingsProvider>
              <Layout />
            </SettingsProvider>
          }
        >
          <Route path="/panel" element={<PanelPage />} />
          <Route path="/registrar" element={<RegistrarPage />} />
          <Route path="/visitantes" element={<VisitantesPage />} />
          <Route path="/historial" element={<HistorialPage />} />

          <Route element={<RequireAdmin />}>
            <Route path="/directorio" element={<DirectorioPage />} />
            <Route path="/usuarios" element={<UsuariosPage />} />
            <Route path="/accesos" element={<AccesosPage />} />
            <Route path="/areas-comunes" element={<AreasComunesPage />} />
            <Route path="/ajustes" element={<AjustesPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/panel" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
